/**
 * Миксин для submenu
 */
export default {
    data() {
        return {
            currentReport: null,
        };
    },
    created() {
        this.setCurrentReport();
    },
    methods: {
        setCurrentReport() {
            const url = new URL(window.location.href);
            // Убираем "/ru/", GET-параметры и получаем нужную часть пути
            this.currentReport = url.pathname.replace(/^\/ru\//, '');
        },
        getLink(link) {
            return sprintf('/%s/%s?domain=%s', window.locale, link, this.domain);
        },
    },
}
